import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    jwt_token: '####'
}

export const TokenSlice = createSlice({
   name : 'widgettoken',
   initialState,
   reducers : {
       updateToken: (state, action) => {
           let payload = action.payload
           console.log(`TokenSlice: updateToken`)
           console.log(payload)
           return {
               ...state,
               jwt_token: payload.jwt_token
           }
       }
   }
});

export const {updateToken} = TokenSlice.actions;
export default TokenSlice.reducer;
